import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';
// 导入活动海报图片
import promo1 from '../assets/images/picosure.jpg';

const content = {
  en: {
    pageTitle: 'Grand Opening Promotion',
    metaTitle: 'Medical Aesthetic Specials & Promotions | Halo Richmond Hill',
    pageDesc: 'Celebrate our grand opening with an exclusive first-visit offer designed just for you.',
    metaDesc: 'Discover limited-time specials, exclusive promotions, and value treatment packages for laser, injectable, and skincare services at Halo Aesthetic Clinic Richmond Hill.',
    currentPromo: {
      title: 'Grand Opening Celebration',
      subtitle: 'First Visit Exclusive',
      description: 'Join us in celebrating our grand opening! Experience our premium aesthetic services with 25% off everything on your first visit. This exclusive offer includes a complimentary consultation to help you discover the perfect treatment plan.Excludes advanced injection and thread lifting services.',
      details: [
        '25% off all services (first visit only)',
        'Complimentary skin analysis consultation',
        'Personalized treatment plan included',
        'Premium aesthetic services available'
      ],
      image: promo1,
      validUntil: 'Limited Time Offer',
      rsvpText: 'Book Your Appointment',
      contactText: 'Contact us today to schedule your first visit and claim this exclusive grand opening offer.'
    },
    upcomingPromos: [
      {
        id: 1,
        title: 'Winter Glow Package',
        description: 'Get ready for winter with our comprehensive skin rejuvenation treatments.',
        comingSoon: 'Coming Soon'
      },
      {
        id: 2,
        title: 'VIP Member Benefits',
        description: 'Exclusive perks and priority booking for our valued members.',
        comingSoon: 'Coming Soon'
      }
    ]
  },
  cn: {
    pageTitle: '开业庆典优惠',
    metaTitle: '医美优惠与限时活动 | Halo Richmond Hill 医美诊所',
    pageDesc: '庆祝我们盛大开业，专为您设计的首次到访专属优惠。',
    metaDesc: '汇聚当下热门光电皮肤管理、注射美容及身体塑形等医美项目的限时优惠与精选疗程套餐。',
    currentPromo: {
      title: '开业庆典',
      subtitle: '首次到访专享',
      description: '加入我们庆祝盛大开业！首次到访享受全场服务25%优惠。此专属优惠包含免费咨询，帮助您发现完美的治疗方案。不包括高级注射和线雕服务。',
      details: [
        '全场服务25%优惠（仅限首次到访）',
        '免费皮肤分析咨询',
        '个性化治疗方案包含在内',
        '高端医美服务可选'
      ],
      image: promo1,
      validUntil: '限时优惠',
      rsvpText: '立即预约',
      contactText: '立即联系我们预约您的首次到访，享受此开业庆典专属优惠。'
    },
    upcomingPromos: [
      {
        id: 1,
        title: '冬日光彩套餐',
        description: '为冬日做好准备，享受我们全面的肌肤焕新护理。',
        comingSoon: '即将推出'
      },
      {
        id: 2,
        title: 'VIP会员特权',
        description: '为我们的尊贵会员提供专属福利和优先预约服务。',
        comingSoon: '即将推出'
      }
    ]
  }
};

const Promo = () => {
  const { lang } = useLang();
  const c = content[lang];
  const canonicalUrl = 'https://www.haloaestheticclinic.com/promo';

  return (
    <div className="bg-softGradient bg-no-repeat bg-top text-text">
      <Helmet>
        <title>{c.metaTitle}</title>
        <meta name="description" content={c.metaDesc} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={c.metaTitle} />
        <meta property="og:description" content={c.metaDesc} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        {/* Event snippet for 网页浏览 conversion page
In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. */}
        <script>
          {`function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-18458381832/6SnuCPThvpcdEIic0uFE',
      'value': 1.0,
      'currency': 'CAD',
      'event_callback': callback
  });
  return false;
}`}
        </script>
      </Helmet>
      {/* 页面标题 */}
      <section className="py-section max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4 text-gray-900">{c.pageTitle}</h1>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">{c.pageDesc}</p>
        </div>
      </section>

      {/* 当前活动 */}
      <section className="py-section bg-softGradient">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* 活动海报 */}
            <div className="order-2 lg:order-1">
              <div className="relative">
                <img
                  src={c.currentPromo.image}
                  alt={c.currentPromo.title}
                  className="w-full h-96 object-cover rounded-xl shadow-card border border-champagne/40"
                />
                <div className="absolute top-4 right-4 bg-[#2E6B4C]/90 text-white px-4 py-2 rounded-xl">
                  <span className="text-sm font-semibold">{c.currentPromo.subtitle}</span>
                </div>
              </div>
            </div>

            {/* 活动详情 */}
            <div className="order-1 lg:order-2">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 border border-champagne/40 shadow-card">
                {/* Title Section */}
                <div className="mb-6">
                  <div className="inline-block px-4 py-1.5 bg-[#2E6B4C]/10 rounded-full mb-3">
                    <p className="text-sm font-semibold text-[#2E6B4C]">{c.currentPromo.subtitle}</p>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">{c.currentPromo.title}</h2>
                  
                  {/* Highlight Badge */}
                  <div className="inline-block mb-4">
                    <div className="bg-gradient-to-br from-[#2E6B4C] to-[#1f4a35] text-white px-6 py-3 rounded-xl shadow-lg">
                      <p className="text-3xl font-bold tracking-tight">
                        {lang === 'en' ? '25% OFF' : '25% 优惠'}
                      </p>
                    </div>
                  </div>
                </div>

                <p className="text-gray-700 mb-6 text-lg leading-relaxed">{c.currentPromo.description}</p>
                
                <div className="space-y-3 mb-6">
                  {c.currentPromo.details.map((detail, index) => (
                    <div key={index} className="flex items-start">
                      <svg
                        className="w-5 h-5 text-[#2E6B4C] mr-3 mt-0.5 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-gray-700">{detail}</span>
                    </div>
                  ))}
                </div>

                <div className="mb-6 p-4 bg-gradient-to-r from-[#fdf6e9] to-[#f5ede0] rounded-lg border border-champagne/40">
                  <p className="text-sm text-gray-600 mb-1">{lang === 'en' ? 'Offer Valid:' : '优惠有效期：'}</p>
                  <p className="text-[#2E6B4C] font-semibold text-lg">{c.currentPromo.validUntil}</p>
                </div>

                <div className="space-y-4">
                  <Link
                    to="/contact"
                    className="inline-block px-6 py-3 rounded-xl shadow-soft transition-all text-gray-900 hover:shadow-glow hover:brightness-110 border border-champagne/60"
                    style={{
                      backgroundImage:
                        'linear-gradient(90deg, rgba(217,195,169,1) 0%, rgba(217,195,169,0.8) 40%, rgba(217,195,169,0.3) 100%)'
                    }}
                  >
                    {c.currentPromo.rsvpText}
                  </Link>
                  <p className="text-sm text-gray-600">{c.currentPromo.contactText}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 即将推出的活动 */}
      <section className="py-section bg-softRadial">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            {lang === 'en' ? 'Upcoming Promotions' : '即将推出的活动'}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {c.upcomingPromos.map((promo) => (
              <div
                key={promo.id}
                className="bg-white/70 backdrop-blur-sm rounded-xl p-6 border border-champagne/40 shadow-card"
              >
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-xl font-bold text-gray-900">{promo.title}</h3>
                  <span className="bg-softGold/80 text-gray-900 px-3 py-1 rounded-full text-sm font-semibold">
                    {promo.comingSoon}
                  </span>
                </div>
                <p className="text-gray-700">{promo.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Promo;
